import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card, InputAdornment, styled, Badge, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import { DesktopDatePicker, LocalizationProvider, PickersDay } from "@mui/lab";
import moment from "moment";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 8,
    top: 8,
    padding: '0 4px',
  },
}));
export default function InboundTruck() {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [key, setKey] = useState("");
  const debouncedKey = useDebounce(key, 500);
  const [etdpol, setEtdpol] = useState([]);
  const [toCountry, setToCountry] = useState('all')
  const [location, setLocation] = useState([])
  const [locationFilter, setLocationFilter] = useState([])
  const [country, setCountry] = useState([]);
  const [toAction, setToAction] = useState('all')
  const [checkAll, setCheckAll] = useState(true);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const SearchDate = (startdate, enddate) => {
    const newData = data.filter((x) => {
      return new Date(x.EtdPol) >= startdate && new Date(x.EtdPol) <= enddate;
    });

    setDataFilter(newData);
  }; 
   const columns = [
    { field: "ShipperRefNo", headerName: "Shipper Ref No.", width: 150 },
    { field: "BookingNo", headerName: "Booking No.", width: 150 },
    { field: "Depot", headerName: "Depot", width: 150 },
    { field: "GateOut", headerName: "GateOut", width: 150 },
    {
      field: "ETDGateOut",
      headerName: "ETDGateOut",
      width: 150,

      valueFormatter: ({ value }) => moment(value).format("yyyy/MM/DD"),
    },
    { field: "GateIn", headerName: "GateIn", },
    {
      field: "ETAGateIn",
      headerName: "ETAGateIn",
      width: 150,
      valueFormatter: ({ value }) => moment(value).format("yyyy/MM/DD"),
    },

    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        console.log(params);
        return (
          <>
            <Link
              to={{
                pathname: `/Truck/EditInboundTruck/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              // onClick={onClickEdit}
              >
                View
              </Button>
            </Link>
          </>
        );
      },
    },
    {
      field: "Remark",
      headerName: "Remark",
      width: 150,

    },
  ];

  //fetch Data
  const getData = async () => {
    try {
      const data = await api.get(
        `api/containermovement/inbound/list?${dateStart ? `startDate=${moment(dateStart).format("yyyy-MM-DD")}` : ""
        }${dateEnd ? `&endDate=${moment(dateEnd).format("yyyy-MM-DD")}` : ""}&keyword=${debouncedKey}${toAction !== 'all' ? `&locationId=${toAction}` : ''}&ToAction=Truck`
      );

      // console.log(data.data);
      setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [debouncedKey, dateStart, dateEnd, toAction]);
  const getCountry = async () => {
    try {
      const res = await api.get("api/country/list");
      const data = await res.data
      if (res.meta.status === true) {
        setCountry(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data
      if (res.meta.status === true) {
        setLocation(data.filter((x) => x?.Status === true));
        setLocationFilter(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getLocation()
    getCountry()
  }, [])
  useEffect(() => {
    if (toCountry !== 'all') {
      const filterLocation = location?.filter((item) => item.CountryId === toCountry)
      setLocationFilter(filterLocation)
      setToAction(filterLocation[0]?.LocationId)
    } else {
      setLocationFilter(location)
    }
  }, [toCountry])

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>

        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            ขาเข้า
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Inbound
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">Truck</Typography>
              <Typography>
                <span>&nbsp;</span> / Inbound
              </Typography>
            </Grid>
          </Grid>
          <Grid
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
            }}
            spacing={1}
          >
            <div style={{ display: "flex" }}>
              <FormControl size="small" sx={{
                width: "15%", marginRight: '10px',
              }}>
                <InputLabel>Country</InputLabel>
                <Select
                  label="Country"
                  value={toCountry}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setToCountry(e.target.value)
                  }}
                // disabled={values.liners !== ""}
                >
                  <MenuItem
                    value={"all"}
                  >
                    ทั้งหมด
                  </MenuItem>
                  {country?.map((x) => (
                    <MenuItem
                      value={x?.CountryId}
                    >
                      {x?.CountryName}
                    </MenuItem>
                  ))}


                </Select>
              </FormControl>
              <FormControl size="small" sx={{
                width: "15%", marginRight: '10px',
              }}>
                <InputLabel>Location</InputLabel>
                <Select
                  label="Location"
                  value={toAction}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {

                    setToAction(e.target.value)
                  }}
                // disabled={values.liners !== ""}
                >
                  <MenuItem
                    value={"all"}
                  >
                    ทั้งหมด
                  </MenuItem>
                  {locationFilter?.map((x) => (
                    <MenuItem
                      value={x?.LocationId}
                    >
                      {x?.LocationName}
                    </MenuItem>
                  ))}


                </Select>
              </FormControl>
              <DesktopDatePicker
                label="dateStart"
                inputFormat="yyyy/MM/dd"
                value={dateStart}
                minDate={new Date("2017-01-01")}
                onChange={async (newValue) => {
                  setDateStart(newValue);
                  setCheckAll(false);
                  await SearchDate(newValue, dateEnd);
                }}
                renderDay={(day, selectedDate, pickersDayProps) => {
                  const isSunny = etdpol?.includes(day.toISOString().slice(0, 10));

                  return (
                    <StyledBadge sx={{ color: 'red' }} badgeContent={isSunny && !pickersDayProps.outsideCurrentMonth ? <div style={{ width: "10px", height: "10px", background: "red", borderRadius: "50%" }}></div> : undefined}>
                      <PickersDay

                        {...pickersDayProps}
                      />
                    </StyledBadge>
                  );
                }}

                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ width: "25%" }}
                    {...params}
                  />
                )}
              />
              <DesktopDatePicker
                label="dateEnd"
                inputFormat="yyyy/MM/dd"
                value={dateEnd}
                minDate={new Date(dateStart)}
                onChange={async (newValue) => {
                  setDateEnd(newValue);
                  setCheckAll(false);
                  await SearchDate(dateStart, newValue);
                }}
                renderDay={(day, selectedDate, pickersDayProps) => {
                  const isSunny = etdpol?.includes(day.toISOString().slice(0, 10));

                  return (
                    <StyledBadge sx={{ color: 'red' }} badgeContent={isSunny && !pickersDayProps.outsideCurrentMonth ? <div style={{ width: "10px", height: "10px", background: "red", borderRadius: "50%" }}></div> : undefined}>
                      <PickersDay

                        {...pickersDayProps}
                      />
                    </StyledBadge>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ width: "25%", marginLeft: "10px", marginRight: '10px' }}
                    {...params}
                  />
                )}
              />

              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                label="Search"
                onChange={(e) => setKey(e.target.value)}
                size="small"
              />
            </div>
          </Grid>
          {/* <Grid
          container
          sx={{ justifyContent: "end" }}
          style={{ marginTop: "10px" }}
          alignItems="center"
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Date Start"
              value={dateStart}
              inputFormat="yyyy/MM/dd"
              minDate={new Date("2017-01-01")}
              onChange={(newValue) => {
                setDateStart(moment(newValue).format("yyyy-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  style={{ width: "200px", marginLeft: "10px" }}
                  {...params}
                />
              )}
            />
            <DesktopDatePicker
              label="Date End"
              value={dateEnd}
              inputFormat="yyyy/MM/dd"
              minDate={dateStart ? dateStart : new Date()}
              onChange={(newValue) => {
                setDateEnd(moment(newValue).format("yyyy-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  style={{
                    width: "200px",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              disableUnderline: true,
            }}
            label="Search"
            onChange={(e) => setKey(e.target.value)}
            size="small"
          />
        </Grid> */}

          <Box
            sx={{
              height: 650,
              width: "100%",
              marginTop: "10px",
              "& .Active": {
                color: "#28A745",
              },
              "& .Inactive": {
                color: "#F53C56",
              },
            }}
          >
            <DataGrid
              getRowId={(r) => r.VoyIn}
              rows={dataFilter}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              hideFooterSelectedRowCount
              disableColumnFilter
              disableColumnMenu
              getCellClassName={(params) => {
                if (params.field === "Status") {
                  return params.value == 1 ? "Active" : "Inactive";
                }
              }}
            />
          </Box>
        </Card>
        {/* {MenuActive.find((x) => x.ActionNo === "A061") && (
        <Link to="/Setting/AddBranch">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )} */}
      </LocalizationProvider>
    </div>
  );
}
